export const METALS = [
  { id: "10k", label: "10K Gold", purity: "41.7% Au" },
  { id: "14k", label: "14K Gold", purity: "58.3% Au" },
  { id: "18k", label: "18K Gold", purity: "75.0% Au" },
  { id: "silver", label: "Sterling Silver", purity: "92.5% Ag" },
  { id: "platinum", label: "Platinum 950", purity: "95.0% Pt" },
];

export const RING_SIZES = (() => {
  const arr = [];
  for (let i = 3; i <= 13; i += 0.5) arr.push(i);
  return arr;
})();

export const THICKNESS = [
  { id: "thin", label: "Thin (1.5–2 mm)" },
  { id: "medium", label: "Medium (2–3 mm)" },
  { id: "thick", label: "Thick (3 mm+)" },
];

export const JUMP_RING_SIZES = [
  { id: "small", label: "Small (4 mm)" },
  { id: "medium", label: "Medium (6 mm)" },
  { id: "large", label: "Large (8 mm+)" },
];

export const STONE_TYPES = [
  { id: "standard", label: "Standard (CZ / semi)" },
  { id: "colored", label: "Colored Gemstone" },
  { id: "small_diamond", label: "Small Diamond" },
];

export const SERVICES = [
  {
    id: "ring_sizing",
    label: "Ring Sizing",
    blurb: "Up or down with measured precision.",
  },
  {
    id: "stone_reset",
    label: "Reset Stones",
    blurb: "Re-secure or replace stones in setting.",
  },
  {
    id: "jump_ring",
    label: "Add Jump Ring",
    blurb: "Soldered jump ring, small to large.",
  },
  {
    id: "chain_repair",
    label: "Chain Repair",
    blurb: "Soldered link & break repair.",
  },
  {
    id: "prong",
    label: "Prong Rebuilding",
    blurb: "Re-tip or rebuild worn prongs.",
  },
  {
    id: "rhodium",
    label: "Rhodium Plating",
    blurb: "Bright white finish replate.",
  },
  {
    id: "polish",
    label: "Polish & Clean",
    blurb: "Hand polish, ultrasonic & steam.",
  },
];

export const formatUSD = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(Number(n || 0));

export const formatGram = (n) =>
  `$${Number(n || 0).toFixed(2)}/g`;
